<template>
  <Common
    :event="realEvent"
    :add-time="0"
    @end="end"
    @realEnd="realEnd"
    :is-count-down="false"
    :is-close="true"
    :bg="bg"
  >
    <a-spin :spinning="isLoading">
      <div class="que-wrap">
        <div class="que-inner">
          <div
            class="que-item"
            v-for="(item, index) in topicList"
            :key="index"
            :class="{'cur-que': index === curTopicIdx}"
          >
            <template v-if="item.topicTemp">
              <component
                v-if="item.component && index === curTopicIdx"
                :is="item.component"
                :topic="item.topicTemp"
                :index="index"
              >
                <p class="que-title" slot="title">
                  <span class="title-index">{{ curTopicIdx + 1 }}.</span>{{ item.topicTemp.tag.name }}
                </p>
              </component>
              <div v-else>
                <p class="que-title" slot="title">
                  <span class="title-index">{{ curTopicIdx + 1 }}</span>.不支持该题型(topicId: {{ item.topicId }} {{ item.topicTemp.tag.name }} {{ item.topicTemp.type }})
                </p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </a-spin>
    <template #bottom>
      <div class="bottom-wrap">
        <a-button type="dashed" :disabled="curTopicIdx === 0 || isLoading" @click="prevClick">
          上一题
        </a-button>
        <a-button type="primary" :disabled="curTopicIdx === topicList.length - 1 || isLoading" @click="nextClick">
          下一题
        </a-button>
      </div>
    </template>
  </Common>
</template>
<script>
import { computed, ref, watch } from '@vue/composition-api'
import Common from './Common.vue'
// import videoService from '@/service/video/index'
import Xuanze from '@/components/Tiku/Xuanze.vue'
import ReadWord from '@/components/Tiku/ReadWord.vue'
import ReadEssay from '@/components/Tiku/ReadEssay.vue'
import { tkSdkNew } from '@/utils/tools.js'
import videoService from '@/service/video/index'
import ti from '@/components/VideoPlayer/images/ti.svg'
import audio from '@/components/VideoPlayer/images/audio.svg'
/**
 * 单步训练
 */
export default {
  components: {
    Common,
    Xuanze,
    ReadWord,
    ReadEssay
  },
  props: {
    event: Object
  },
  setup(props, { emit, root }) {
    const isLoading = ref(false)
    const curTopicIdx = ref(null)
    const params = computed(() => props.event.params)

    const realEvent = computed(() => {
      const res = props.event || {}
      res.params.duration = 5
      return {
        ...props.event
      }
    })
    const topicList = computed(() => params.value.topicList || [])

    // 背景 icon
    const bg = ref(ti)

    watch(
      () => curTopicIdx.value,
      async val => {
        const cur = topicList.value[val]
        if (cur) {
          // 从题库获取
          const { topicId } = cur
          await getQuesstionInfo(val, topicId)
          bg.value = setBg(val)
        }
        root.$nextTick(() => {
          // 渲染公式
          setTimeout(() => {
            tkSdkNew.runMathjax()
          }, 0)
        })
      },
      {
        immediate: true
      }
    )
    // 初始化完成
    curTopicIdx.value = 0

    async function getDiy(topicId) {
      return await videoService.getNewQuesstionInfo({ topicId })
      // return new Promise((resolve, reject) => {
      //   fetch(`https://yapi.aixuexi.com/mock/787/bfe/diy/tk?topicId=${topicId}`).then(response => response.json()).then(data => {
      //     resolve(data.body)
      //   }).catch(reject)
      // })
    }

    function setBg(idx) {
      const cur = topicList.value[idx]
      if (cur && cur.topicTemp) {
        const { type } = cur.topicTemp
        // 跟读的
        if ([8, 9, 10].indexOf(type) !== -1) {
          return audio
        }
      }
      return ti
    }

    /**
     * 获取题库题
     */
    async function getQuesstionInfo(index, topicId) {
      const temp = topicList.value[index].topicTemp
      if (temp) {
        return
      }
      isLoading.value = true
      try {
        const res = await getDiy(topicId)
        const { type } = res
        // 所有题型：http://iwork.gaosiedu.com/pages/viewpage.action?pageId=139307541
        // 单步训练支持的题型
        const componentMap = {
          // 选择题
          1: Xuanze,
          // 判断题
          3: Xuanze,
          // 跟读单词
          8: ReadWord,
          // 跟读句子
          9: ReadWord,
          // 跟读短文
          10: ReadEssay
        }
        topicList.value[index].topicTemp = res
        topicList.value[index].component = componentMap[type]
      } catch (e) {
      } finally {
        isLoading.value = false
      }
    }

    function end() {
      // 倒计时结束
      emit('end', props.event)
    }
    function realEnd() {
      // 倒计时结束
      emit('realEnd', props.event)
    }
    function prevClick() {
      curTopicIdx.value = curTopicIdx.value - 1
    }
    function nextClick() {
      curTopicIdx.value = curTopicIdx.value + 1
    }
    return {
      params,
      end,
      realEnd,
      topicList,
      realEvent,
      curTopicIdx,
      prevClick,
      nextClick,
      isLoading,
      bg
    }
  }
}
</script>
<style lang="less" scoped>
.que-item {
  margin: 0;
  display: none;
  height: 100%;
  &.cur-que {
    display: block;
  }
}
.que-inner {
  height: 306px;
}
.bottom-wrap {
  padding-bottom: 32px;
  display: flex;
  justify-content: center;
  button {
    margin: 0 4px;
  }
}
</style>
